import {Image, Result} from "antd-mobile";

const PayFail = () => {
    return <div style={{backgroundColor: '#F5F6FA', height: '100vh', display: "flex", flexDirection: "column", padding: '0 12px', justifyContent: "center", textAlign: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 25}}>
            <Image src={require('../../assets/icon_ego_logo.jpg')} style={{width: 100}}/>
        </div>
        <Result status='error' title='Repayment Failed' description='Payment Failed, Please make a new payment!!!'/>
    </div>
}
export default PayFail
